import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import styled from '@emotion/styled';
import { alpha } from '@mui/system';

const InfoWrapper = styled('div')(
  ({ theme }) => ({
    marginBottom: 28,
    color: alpha(theme.palette.text.secondary, 0.4),
    fontFamily: 'CircularStd',
    fontSize: 15,
  }),
  addHighContrastStyles(({ theme }) => ({
    color: theme.palette.text.secondary,
  })),
);

export default InfoWrapper;
